const Handlebars = require('handlebars');

module.exports = function(blocks) {
    if (!Array.isArray(blocks)) return '';

    return new Handlebars.SafeString("<div class='formatted-text'>" + blocks.map(block => {
        switch (block.type) {
            case 'paragraph':
                return new Handlebars.SafeString(`<p>${textBlock(block.children)}</p>`);
            
            case 'heading':
                const level = block.level || 1;
                return `<h${level}>${textBlock(block.children)}</h${level}>`;
            
            case 'list':
                const tag = block.format === 'ordered' ? 'ol' : 'ul';
                const items = block.children.map(item => `<li>${textBlock(item.children)}</li>`).join('');
                return `<${tag}>${items}</${tag}>`;
            
            case 'quote':
                return `<blockquote>${textBlock(block.children)}</blockquote>`;
            
            case 'code':
                return `<pre><code>${escapeHTML(block.children.map(c => c.text).join(''))}</code></pre>`;
            
            case 'image':
                const img = block.image;
                return `<img src="${img.url}" alt="${img.alternativeText || ''}" width="${img.width || ''}" height="${img.height || ''}" />`;
            
            default:
                return '';
        }
    }).join('') + "</div>");
}

function textBlock(children = []) {
    return children.map(child => {
        let text = escapeHTML(child.text || '');
        
        if (child.bold) text = `<strong>${text}</strong>`;
        if (child.italic) text = `<em>${text}</em>`;
        if (child.underline) text = `<u>${text}</u>`;
        if (child.strikethrough) text = `<del>${text}</del>`;
        if (child.code) text = `<code>${text}</code>`;
        
        return text;
    }).join('');
}

function escapeHTML(str) {
    return str.replace(/[&<>'"]/g, 
        tag => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[tag] || tag)
    );
}